import React from 'react';

import { db } from 'firebaseConfig';

import { LanguageProvider } from 'context/LanguageContext';
import { NavigationProvider } from 'context/NavigationContext';
import { NodePeekProvider } from 'context/NodePeekContext';
import { ProgressProvider } from 'context/ProgressContext';
import { IconsProvider } from 'context/IconsContext';
import { CalendarTimelineProvider } from 'context/CalendarTimelineContext';
import { CartProvider } from 'context/CartContext';
import { EngagementProvider } from 'context/EngagementContext';
import { NodeWorkflowProvider } from 'context/NodeWorkflowContext';
import { UIProvider } from 'context/UIContext';
import { StartupStatusProvider } from 'context/StartupStatusContext';
import { UserProvider } from 'context/UserContext';
import { OnlineProvider } from 'context/OnlineContext';
import { WorkspaceProvider } from 'context/WorkspaceContext';
import { DatabaseProvider } from 'context/DatabaseContext';
import { NodeTypesProvider } from 'context/NodeTypesContext';

const AppProviders = ({ children }) => {
  return (
    <LanguageProvider>
      <NavigationProvider>
        <NodePeekProvider>
          <ProgressProvider>
            <IconsProvider>
              <CalendarTimelineProvider>
                <CartProvider>
                  <EngagementProvider>
                    <NodeWorkflowProvider>
                      <UIProvider>
                        <StartupStatusProvider>
                          <UserProvider>
                            <OnlineProvider>
                              <WorkspaceProvider>
                                <DatabaseProvider>
                                  <NodeTypesProvider db={db} subscribe={true}>
                                    {children}
                                  </NodeTypesProvider>
                                </DatabaseProvider>
                              </WorkspaceProvider>
                            </OnlineProvider>
                          </UserProvider>
                        </StartupStatusProvider>
                      </UIProvider>
                    </NodeWorkflowProvider>
                  </EngagementProvider>
                </CartProvider>
              </CalendarTimelineProvider>
            </IconsProvider>
          </ProgressProvider>
        </NodePeekProvider>
      </NavigationProvider>
    </LanguageProvider>
  );
};

export default AppProviders;
